<template>
  <div>
    <div v-if="hasServicePermissions('OptimiseBatteryHealthEstimation')">
      <h2 v-if="batteryHealth" class="nominal-capacity">Nominal capacity:
        {{ this.batteryHealth.estimation.maxCapacity }}mAh</h2>
      <line-chart v-if="batteryHealth" :chartdata="chartData" :options="options"/>
      <no-data :show="!batteryHealth && !batteryHealthLoading"/>
      <div v-if="batteryHealthLoading">
        <loader :show="true"/>
      </div>
    </div>
  </div>
</template>

<script>

import LineChart from "@/components/chart-types/LineChart.vue";
import {mapActions, mapGetters} from 'vuex'
import Loader from "@/components/Loader.vue";
import NoData from "@/components/NoData.vue";

export default {
  name: 'DeviceCharts',
  components: {Loader, LineChart, NoData},
  data() {
    let xAxes = [
      {
        id: 'xAxis1',
        offset: true,
        gridLines: {
          offsetGridLines: true
        },
      }
    ];

    return {
      options: {
        responsive:
            true,
        maintainAspectRatio:
            true,
        aspectRatio:
            3,
        plugins: {
          legend:
              {
                display: false,
              },
        },
        tooltips: {
          callbacks: {}
        },
        scales: {
          xAxes: xAxes,
          yAxes:
              {
                beginAtZero: true
              }
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'selectedDevice',
      'batteryHealth',
      'batteryHealthLoading',
      'hasServicePermissions',
      'types',
    ]),
    chartData() {
      let labels = Array.from(new Set(Object.keys(this.batteryHealth.history).concat(Object.keys(this.batteryHealth.estimation.estimations))))
      let padding1 = new Array(Math.max(Object.keys(this.batteryHealth.estimation.estimations).length - 1, 0)).fill(null);
      let padding2 = new Array(Math.max(Object.keys(this.batteryHealth.history).length - 1, 0)).fill(null);
      return {
        labels: labels,
        datasets:
            [
              {
                data: Object.values(this.batteryHealth.history).concat(padding1),
                fill: false,
                borderColor: "rgba(0, 40, 58, 1)",
              },
              {
                data: padding2.concat(Object.values(this.batteryHealth.estimation.estimations)),
                fill: false,
                borderColor: "rgba(251, 224, 37, 1)",
              },
            ]
      }
    },
  },
  methods: {
    ...mapActions([
      'downloadDeviceBatteryHealth'
    ]),
  },
  mounted() {
    if (this.hasServicePermissions('OptimiseBatteryHealthEstimation')) this.downloadDeviceBatteryHealth(this.selectedDevice.asset_number)
  }
}
</script>

<style lang="sass" scoped>
.nominal-capacity
  padding-bottom: 5px

.case-number
  padding: 5px
  text-align: left

tr
  .odd
    @apply bg-gray-100
</style>
